import { useDocumentProperties } from "./useDocumentProperties";

export function useDocumentIds() {
  const { data: documentProperties, error, isLoading } = useDocumentProperties();
  const accountId = documentProperties?.AccountId;
  const matterId = documentProperties?.MatterId;

  return { accountId, matterId, error, isLoading };
}
